import { render, staticRenderFns } from "./activityAdmission.html?vue&type=template&id=2d849901&scoped=true&external"
import script from "./activityAdmission.vue?vue&type=script&lang=js"
export * from "./activityAdmission.vue?vue&type=script&lang=js"
import style0 from "./activityAdmission.css?vue&type=style&index=0&id=2d849901&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d849901",
  null
  
)

export default component.exports